import core_constants from "Core/config/constants";

/**
 * Use for label's property field key name
 */
export const api = core_constants.api;

// Use for services' key name
export const services = core_constants.services;

export const services_pricing = {
    rate: {
        [services.name.SMS_SERVICE]: 0,
        [services.name.PHONE_CALL_SERVICE]: 0,
        [services.name.COD_SERVICE]: 0.5,
        [services.name.PICKUP_SERVICE]: 0,
        [services.name.POD]: 0,
        [services.name.VFL]: 0,
    },
};

export const services_pricing_formula = {
    [services.name.SMS_SERVICE]: (phoneCount) =>
        phoneCount * services_pricing.rate[services.name.SMS_SERVICE],
    [services.name.PHONE_CALL_SERVICE]: (phoneCount) =>
        phoneCount * services_pricing.rate[services.name.PHONE_CALL_SERVICE],
    // [services.name.COD_SERVICE]: amount => (amount / 100) * services_pricing.rate[services.name.COD_SERVICE],
    [services.name.COD_SERVICE]: (amount) => Math.round((1 / 100) * amount),
    [services.name.PICKUP_SERVICE]: () =>
        services_pricing.rate[services.name.PICKUP_SERVICE],
    [services.name.POD]: services_pricing.rate[services.name.POD],
    [services.name.VFL]: services_pricing.rate[services.name.VFL],
};

// Use for services' key name to parse locale key name
export const service_locale_enum = {
    // use to change services and services fee keys to locale key
    [services.fee.COD_FEE]: "cod_fee",
    [services.fee.COD_CHARGE]: "cod_charge",
    [services.fee.SMS_FEE]: "sms_service_fee",
    [services.fee.SHIPPING_FEE]: "shipping_service_fee",
    [services.fee.PICKUP_SERVICE_FEE]: "pickup_fee",
    [services.fee.PHONE_CALL_FEE]: "phonecall_service_fee",
    [services.fee.TAX_FEE]: "tax",
    [services.fee.RETURN_FEE]: "return_fee",
    [services.fee.POD_FEE]: "pod_fee",
    [services.fee.VFL_FEE]: "vfl_fee",
    [services.fee.HOLE_MAIL_FEE]: "hold_mail_fee",
    [services.fee.CHANGE_DESTINATION_FEE]: "change_destination_fee",
    [services.fee.CANCELLATION_FEE]: "cancelation_fee",
    [services.name.SMS_SERVICE]: "sms_service",
    [services.name.COD_SERVICE]: "cod_service",
    [services.name.SHIPPING]: "shipping_service",
    [services.name.PICKUP_SERVICE]: "pickup",
    [services.name.PHONE_CALL_SERVICE]: "phone_call_service",
};

// Use for label status key
export const label_status_enum = {
    SEND_TO_MMPOST: "send_to_mmpost",
    CREATED: "created",
    PENDING: "pending",
    PROCESS: "process",
    ACCEPT_FROM_ORIGIN_BRANCH: "accept_from_origin_branch",
    ACCEPT_BY_TRANSPORT: "accept_by_transport",
    SENDBACK_TO_TRANSPORT: "sendback_to_transport",
    SEND_TO_DESTINATION_BRANCH: "send_to_destination_branch",
    ARRIVED_TO_DESTINATION_BRANCH: "arrived_to_destination_branch",
    SEND_TO_DESTINATION_ADDRESS: "send_to_destination_address",

    DELIVERED: "delivered",
    SENTBACK_TO_CUSTOMER: "sentback_to_customer",
    REJECT: "reject",

    // If forward label, require this status before "ARRIVED_TO_DESTINATION_BRANCH"
    SEND_TO_FORWARD_BRANCH: "send_to_forward_branch",
    ARRIVED_TO_FORWARD_BRANCH: "arrived_to_forward_branch",
    SEND_FROM_FORWARD_BRANCH: "send_from_forward_branch",

    // If redirect label, require this status before "SEND_TO_DESTINATION_ADDRESS"
    SEND_FROM_REDIRECT_BRANCH: "send_from_redirect_branch",

    // If return label, require this status after "SEND_TO_DESTINATION_ADDRESS"
    SENDBACK_TO_DESTINATION_BRANCH: "sendback_to_destination_branch",
    ARRIVEDBACK_TO_DESTINATION_BRANCH: "arrivedback_to_destination_branch",
    SENDBACK_TO_ORIGIN_BRANCH: "sendback_to_origin_branch",
    ARRIVED_TO_ORIGIN_BRANCH: "arrived_to_origin_branch",
    SENDBACK_TO_ORIGIN_ADDRESS: "sendback_to_origin_address",

    REDIRECTED: "redirected",

    MISSING: "missing",
    SCHEDULE_RETURN: "schedule_return",
    RETURN_CONFIRMED: "return_confirmed",
    MP_RETURN_CONFIRMED: "mpost_return_confirmed",
    PICKUP_COURIER_LEADER: "pickup_courier_leader",
    PICKUP_COURIER: "pickup_courier",
    POSTMAN_HAND_OVER: "postman_hand_over",
    REJECT: "reject",
    RETURN_CONFIRMED: "return_confirmed",
    PENDING_REJECT: "pending_reject",
    PENDING_RETURN_CONFIRM: "pending_return_confirmed"
};

export const label_status_locale_enum = {
    [label_status_enum.SEND_TO_MMPOST]: "send_to_mmpost",
    [label_status_enum.CREATED]: "created_status",
    [label_status_enum.PENDING]: "pending_status",
    [label_status_enum.PROCESS]: "process",
    [label_status_enum.ACCEPT_FROM_ORIGIN_BRANCH]:
        "accept_from_origin_branch_status",
    [label_status_enum.ACCEPT_BY_TRANSPORT]: "accept_by_transport_status",
    [label_status_enum.SENDBACK_TO_TRANSPORT]: "sendback_to_transport_status",
    [label_status_enum.SEND_TO_DESTINATION_BRANCH]:
        "send_to_destination_branch_status",
    [label_status_enum.ARRIVED_TO_DESTINATION_BRANCH]:
        "arrived_to_destination_branch_status",
    [label_status_enum.ARRIVEDBACK_TO_DESTINATION_BRANCH]:
        "arrivedback_to_destination_branch_status",
    [label_status_enum.SEND_TO_DESTINATION_ADDRESS]:
        "send_to_destination_address_status",
    [label_status_enum.DELIVERED]: "delivered_status",
    [label_status_enum.SENTBACK_TO_CUSTOMER]: "sentback_to_customer",

    [label_status_enum.SEND_TO_FORWARD_BRANCH]: "send_to_forward_branch_status",
    [label_status_enum.ARRIVED_TO_FORWARD_BRANCH]:
        "arrived_to_forward_branch_status",
    [label_status_enum.SEND_FROM_FORWARD_BRANCH]:
        "send_from_forward_branch_status",
    [label_status_enum.SEND_FROM_REDIRECT_BRANCH]: "send_from_redirect_branch",

    [label_status_enum.SENDBACK_TO_DESTINATION_BRANCH]:
        "sendback_to_destination_branch",
    [label_status_enum.SENDBACK_TO_ORIGIN_BRANCH]: "sendback_to_origin_branch",
    [label_status_enum.ARRIVED_TO_ORIGIN_BRANCH]: "arrived_to_origin_branch",
    [label_status_enum.SENDBACK_TO_ORIGIN_ADDRESS]:
        "sendback_to_origin_address",
    [label_status_enum.MP_RETURN_CONFIRMED]: "mpost_return_confirmed",
};

export const report_tab_status_enum = {
    accept_enum: {
        pending: label_status_enum.PENDING,
        accepted: label_status_enum.ACCEPT_FROM_ORIGIN_BRANCH,
        approved: label_status_enum.ACCEPT_FROM_ORIGIN_BRANCH,
        process: 'process',
        arrived_to_destination_branch: label_status_enum.ARRIVED_TO_DESTINATION_BRANCH,
        success: label_status_enum.DELIVERED,
        delivered: label_status_enum.DELIVERED,
        return: label_status_enum.SENTBACK_TO_CUSTOMER,
    },
    merchant_accept_enum: {
        pending         : 'm_accept_count',
        accepted        : 'm_accept_count',
        process         : 'm_process_count',
        delivered       : 'm_delivered_count',
        ongoing_return  : 'm_ongoing_return',
        return    : 'm_returned_count',
        multi_label_print : 'multi_label_print'
    },
    merchant_clearance_enum: {
        cod_pending  : 'pending',
        cod_delivered : 'delivered'
    },
};

// Use to get label status key step by step
export const label_status_process_enum = {
    normal: [
        "PENDING",
        "ACCEPT_FROM_ORIGIN_BRANCH",
        "ACCEPT_BY_TRANSPORT",
        "SEND_TO_DESTINATION_BRANCH",
        "ARRIVED_TO_DESTINATION_BRANCH",
        "SEND_TO_DESTINATION_ADDRESS",
        "DELIVERED",
    ],
    direct: [
        "PENDING",
        "ACCEPT_FROM_ORIGIN_BRANCH",
        "SEND_TO_DESTINATION_ADDRESS",
        "DELIVERED",
    ],
    direct_return: [
        "PENDING",
        "ACCEPT_FROM_ORIGIN_BRANCH",
        "SEND_TO_DESTINATION_ADDRESS",
        "SENDBACK_TO_ORIGIN_BRANCH",
        "SENDBACK_TO_ORIGIN_ADDRESS",
        "SENTBACK_TO_CUSTOMER", //edited DELIVER,
        "RETURN_CONFIRMED",
    ],
    fail_return: [
        "SENDBACK_TO_ORIGIN_BRANCH",
        "SENDBACK_TO_ORIGIN_ADDRESS",
        "SENDBACK_TO_ORIGIN_BRANCH",
        "SENDBACK_TO_ORIGIN_ADDRESS",
    ],
    forward: [
        "PENDING",
        "ACCEPT_FROM_ORIGIN_BRANCH",
        "ACCEPT_BY_TRANSPORT",
        "SEND_TO_FORWARD_BRANCH",
        "ARRIVED_TO_FORWARD_BRANCH",
        "SEND_FROM_FORWARD_BRANCH",
        "ACCEPT_BY_TRANSPORT",
        "SEND_TO_DESTINATION_BRANCH",
        "ARRIVED_TO_DESTINATION_BRANCH",
        "SEND_TO_DESTINATION_ADDRESS",
        "DELIVERED",
    ],
    redirect: [
        "PENDING",
        "ACCEPT_FROM_ORIGIN_BRANCH",
        "ACCEPT_BY_TRANSPORT",
        "SEND_TO_DESTINATION_BRANCH",
        "ARRIVED_TO_DESTINATION_BRANCH",
        "SEND_FROM_REDIRECT_BRANCH",
        "ACCEPT_BY_TRANSPORT",
        "SEND_TO_DESTINATION_BRANCH",
        "ARRIVED_TO_DESTINATION_BRANCH",
        "SEND_TO_DESTINATION_ADDRESS",
        "DELIVERED",
    ],
    return: [
        "PENDING",
        "ACCEPT_FROM_ORIGIN_BRANCH",
        "ACCEPT_BY_TRANSPORT",
        "SEND_TO_DESTINATION_BRANCH",
        "ARRIVED_TO_DESTINATION_BRANCH",
        "SEND_TO_DESTINATION_ADDRESS",
        "SENDBACK_TO_DESTINATION_BRANCH",
        "ARRIVEDBACK_TO_DESTINATION_BRANCH",
        "SEND_TO_DESTINATION_ADDRESS_AGAIN",
        "ARRIVEDBACK_TO_DESTINATION_BRANCH_AGAIN",
        "SENDBACK_TO_ORIGIN_BRANCH",
        "SENDBACK_TO_TRANSPORT",
        "ARRIVED_TO_ORIGIN_BRANCH",
        "SENDBACK_TO_ORIGIN_ADDRESS",
        "SENTBACK_TO_CUSTOMER",
        "RETURN_CONFIRMED",
    ],
};

export const label_status_recognize_key = {
    // to recognize label's shipping type by see label's current status list (list contain the following status or not) => search latest from backward
    // [label_status_enum.SEND_TO_FORWARD_BRANCH]: "forward",
    [label_status_enum.SENDBACK_TO_DESTINATION_BRANCH]: "return",
    [label_status_enum.SEND_FROM_REDIRECT_BRANCH]: "redirect",
};

export const tab_status_enum = {
    accept_enum: {
        inbox: "s_pending_count",
        pending: "s_accept_count",
        ongoing: "s_send_count",
        ondelivery: label_status_enum.SEND_TO_DESTINATION_ADDRESS,
        sent: "s_delivered_count",
        return: "s_return_count",
        resent_return: "d_returned_count",
        send_back_to_source: "s_returned_count",
        issue_pending: label_status_enum.SEND_FROM_REDIRECT_BRANCH,
        issue: label_status_enum.MISSING,
        w_pending: "w_accept_count",
        w_forward: "w_forward",
    },
    deliver_enum: {
        inbox: "d_pending_count",
        pending: "d_delivery_pending_count",
        pickup: "d_pending_pickup_count",
        ongoing: "d_send_count",
        delivered: "d_delivered_count",
        fail_deliver: "d_fail_deliver_count",
        return: "d_return_count",
        deliver_failed: "d_fail_deliver_count",
        resent_return: "d_returned_count",
        send_back_to_source: label_status_enum.SENDBACK_TO_ORIGIN_BRANCH,
        issue_pending: label_status_enum.SEND_FROM_REDIRECT_BRANCH,
        issue: label_status_enum.MISSING,
        reschedule: "d_reschedule",
        postman_handover: "d_postman_handover",
    },
    mmpost_enum: {
        pending: label_status_enum.PENDING,
        process: "process",
        complete: "complete",
        return: "return",
    },
    merchant_label_enum: {
        pending         : 'm_prestore_pending_count', //'m_pending_count',
        process         : 'm_process_count',
        // process         : 'm_process_label_count',
        success         : 'm_delivered_count',
        ongoing_return  : 'm_ongoing_return',
        return          : 'm_returned_count',
        return_label    : 'd_returned_count',
      }
};

export const region_slug = {
    "Kachin State": "KCN",
    "Kayah State": "KYA",
    "Kayin State": "KYN",
    "Chin State": "CHN",
    "Sagaing Region": "SGI",
    "Tanintharyi Region": "TYG",
    "Bago Region (East)": "BGOE",
    "Bago Region (West)": "BGOW",
    "Magway Region": "MGW",
    "Mandalay Region": "MDY",
    "Mon State": "MON",
    "Rakhine State": "RKH",
    "Yangon Region": "YGN",
    "Shan State (South)": "SHNS",
    "Shan State (North)": "SHNN",
    "Shan State (East)": "SHNE",
    "Ayeyarwady Region": "AYY",
    "Naypyitaw Union Territory": "NPT",
};

export const mailbag_process_enum = {
    PENDING: "pending",
    PROCESS: "process",
    ACCEPT_BY_TRANSPORT: "accept_by_transport",
    SEND_FROM_TRANSPORT: "send_from_transport",
    ARRIVED_FROM_TRANSPORT: "arrived_from_transport",
    CHECK_IN: "checkin_transit",
    CHECK_OUT: "checkout_transit",
    COMPLETE: "complete",
};

export const pickup_request_status_enum = {
    UNASSIGNED: "unassigned",
    PENDING: "pending",
    ONGOING: "ongoing",
    COMPLETE: "complete",
    FAILED: "failed",
};

export const report_region_chooser_enum = {
    ALL: "all_branch",
    REGION: "branch_collection",
    BRANCH: "branch",
};

export const report_period_enum = {
    DAILY: "daily",
    MONTHLY: "monthly",
    YEARLY: "yearly",
    DATE_RANGE: "range",
};

export const export_type_enum = {
    BRANCH: "branch",
    REGION: "branch_collection",
    ALL: "all_branch",
};

export const pickup_request_status = {
    UNASSIGNED: "unassigned",
    PENDING: "pending",
    ONGOING: "ongoing",
    COMPLETE: "complete",
    FAILED: "failed",
};

export const pickup_request_log_status_enum = {
    UNASSIGNED: "unassigned",
    PENDING: "pending",
    ACCEPT: "accept",
    DENY: "deny",
    COMPLETE: "complete",
    FAILED: "failed",
};

export const cod_services_state = {
    STATUS_ONGOING: "ongoing",
    STATUS_PROCESS: "process",
    STATUS_READY_TO_CLEARANCE: "ready_to_clearance",
    STATUS_CLEARANCE: "clearance",
    STATUS_COMPLETE: "complete",
    STATUS_CANCEL: "cancel",
};

export const pickup_request_api_enum = {
    BRANCH_ID: "branch_id",
    POSTMAN_ID: "postman_id",
    NAME: "name",
    PHONE: "phone",
    INCLUDE_PRODUCT: "include_products",
    COUNTS: "counts",
    ACCEPT_COUNT: "accept_counts",
    WEIGHT: "weight",
    TIME_REQUEST: "time_request",
    STATUS: "status",
};

export const mmpost_branch_enum = {
    YANGON: "cJAHTnveQNiHuomT85cWADAFEAX232aA4222",
    MANDALAY: "cJAHTnveQNiHuomT85cWADAFEAX232aA4223",
};

export const label_type = {
    FCS_EXPRESS: "fcs_express",
    MMPOST: "mm_post",
};

export const hand_over_status_enum = {
    STATUS_ACTIVE: "active",
    STATUS_HANDOVER: "hand_over",
    STATUS_INACTIVE: "inactive",
};

export const branch_types = {
    FCS: "fcs",
    AGENT: "agent",
};

export const ticket_types = {
    SHIPPING: "shipping",
    OPERATION: "operation",
    TECHNOLOGY: "technology",
};

export const accept_types = core_constants.accept_types;

export const purchase_types = core_constants.purchase_types;
export const purchase_types_config = core_constants.purchase_types_config;

export const label_types = core_constants.label_types;

export const item_types = core_constants.item_types;

export const service_types = core_constants.service_types;
export const service_types_config = core_constants.service_types_config;

export const label_service_type = core_constants.label_service_type;

export default {
    api,
    services,
    service_locale_enum,
    label_status_enum,
    label_status_process_enum,
    label_status_locale_enum,
    label_status_recognize_key,
    tab_status_enum,
    services_pricing_formula,
    region_slug,
    mailbag_process_enum,
    pickup_request_status_enum,
    report_region_chooser_enum,
    report_period_enum,
    export_type_enum,
    pickup_request_status,
    pickup_request_log_status_enum,
    cod_services_state,
    pickup_request_api_enum,
    mmpost_branch_enum,
    label_type,
    hand_over_status_enum,
    branch_types,
    accept_types,
    purchase_types,
    purchase_types_config,
    label_types,
    item_types,
    service_types,
    service_types_config,
    ticket_types,
    report_tab_status_enum,
    label_service_type,
};
